import { DownloadIcon } from "@twilio-paste/icons/esm/DownloadIcon";
import { AttachmentPreviewProps } from "../definitions";
import {
  ChatAttachment,
  ChatAttachmentDescription,
  ComposerAttachmentCard,
} from "@twilio-paste/core/chat-log";
import { Box } from "@twilio-paste/core/box";
import { Truncate } from "@twilio-paste/core/truncate";
import { Text } from "@twilio-paste/core/text";
import { Spinner } from "@twilio-paste/core/spinner";

const previewFileIcon = (file: File) => {
  if (file.type.includes("image")) {
    return (
      <img
        src={URL.createObjectURL(file)}
        alt="Preview"
        style={{ maxHeight: "2.5rem" }}
      />
    );
  }
  return <DownloadIcon color="colorTextIcon" decorative />;
};

const sendIcon = () => {
  return <Spinner decorative={false} title="Loading" />;
};

const AttachmentsPreview = ({
  files,
  onDeleteFile,
  isSending = false,
  disabled = false,
}: AttachmentPreviewProps) => {
  const getFileSize = (file: File): string => {
    const fileSizeInKb = file.size / 1024;
    if (fileSizeInKb < 1024) {
      return `${fileSizeInKb.toFixed(2)} KB`;
    }
    return `${(fileSizeInKb / 1024).toFixed(2)} MB`;
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      columnGap="space40"
      overflowX="scroll"
      paddingY="space50"
    >
      {files.map((file, index) => (
        <Box
          maxWidth="size20"
          key={index}
          style={{
            pointerEvents: disabled ? "none" : "auto",
            opacity: isSending ? 0.5 : 1,
          }}
        >
          <ComposerAttachmentCard
            onDismiss={() => {
              !disabled && !isSending && onDeleteFile(file);
            }}
          >
            <ChatAttachment
              attachmentIcon={isSending ? sendIcon() : previewFileIcon(file)}
            >
              <Text as="span" color={"colorTextPrimary"}>
                <Truncate title={file.name}>{file.name}</Truncate>
              </Text>
              <ChatAttachmentDescription>
                {getFileSize(file)}
              </ChatAttachmentDescription>
            </ChatAttachment>
          </ComposerAttachmentCard>
        </Box>
      ))}
    </Box>
  );
};

export default AttachmentsPreview;
